import React, { useEffect, useState } from "react";
import { fetchPublicContact } from "../services/siteApi"; // <-- new API service

const ContactSection = () => {
  const [contact, setContact] = useState({
    email: "",
    phone: "",
    label_email: "Email",
    label_phone: "WhatsApp",
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadContact = async () => {
      setLoading(true);
      try {
        const data = await fetchPublicContact(); // backend returns { label_email, email, label_phone, phone }
        if (data) setContact(data);
      } catch (err) {
        console.error("Failed to load contact info:", err);
      } finally {
        setLoading(false);
      }
    };
    loadContact();
  }, []);

  return (
    <section id="contact" className="container my-5">
      <h2>Contact Us</h2>

      {loading ? (
        <p>Loading contact info...</p>
      ) : (
        <div className="contact-direct mt-4">
          {/* Email */}
          <div className="contact-method mb-3">
            <span className="contact-icon" aria-label="Email" title="Email">
              &#9993;
            </span>
            <span className="contact-label">
              {contact.label_email || "Email"}:
            </span>
            <a
              href={`mailto:${contact.email}`}
              className="contact-link"
              style={{ marginLeft: "0.5em" }}
            >
              {contact.email || "Not available"}
            </a>
          </div>

          {/* WhatsApp / Phone */}
          <div className="contact-method">
            <span
              className="contact-icon"
              aria-label="WhatsApp"
              title="WhatsApp"
            >
              <svg
                width="1.2em"
                height="1.2em"
                viewBox="0 0 32 32"
                style={{ verticalAlign: "middle", marginRight: "0.1em" }}
              >
                <circle cx="16" cy="16" r="16" fill="#25D366" />
                <path
                  d="M23.5 8.5A9.94 9.94 0 0 0 16 6a10 10 0 0 0-8.7 14.9L6 26l5.2-1.3A10 10 0 1 0 23.5 8.5zm-7.5 15a8.1 8.1 0 0 1-4.1-1.1l-0.3-0.2-3.1 0.8 0.8-3-0.2-0.3A8.1 8.1 0 1 1 16 23.5zm4.5-6.1c-0.2-0.1-1.2-0.6-1.4-0.7-0.2-0.1-0.4-0.1-0.6 0.1-0.2 0.2-0.7 0.7-0.9 0.9-0.2 0.2-0.3 0.2-0.5 0.1-0.2-0.1-0.8-0.3-1.5-1-0.6-0.6-1-1.3-1.1-1.5-0.1-0.2 0-0.3 0.1-0.5 0.1-0.2 0.2-0.3 0.3-0.5 0.1-0.2 0-0.4-0.1-0.6-0.1-0.2-0.6-1.2-0.8-1.6-0.2-0.4-0.4-0.3-0.6-0.3-0.2 0-0.4 0-0.6 0-0.2 0-0.5 0.1-0.7 0.3-0.2 0.2-0.9 0.9-0.9 2.1 0 1.2 0.9 2.3 1 2.5 0.1 0.2 1.7 2.7 4.2 3.6 0.6 0.2 1.1 0.3 1.5 0.2 0.5-0.1 1.5-0.6 1.7-1.2 0.2-0.6 0.2-1.1 0.1-1.2z"
                  fill="#fff"
                />
              </svg>
            </span>
            <span className="contact-label">
              {contact.label_phone || "WhatsApp"}:
            </span>
            <a
              href={`https://wa.me/${contact.phone?.replace(/\D/g, "")}`}
              className="contact-link"
              target="_blank"
              rel="noopener noreferrer"
              style={{ marginLeft: "0.5em" }}
            >
              {contact.phone || "Not available"}
            </a>
          </div>
        </div>
      )}
    </section>
  );
};

export default ContactSection;
